/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import styled from "@emotion/styled"

import Header from "./header"
import * as Fooer from "./footer"
import "./layout.css"

const Main = styled.main({
  paddingTop: "30px",
  "@media (max-width: 960px)": {
    padding: "30px 10px 0",
  },
})

const Layout = ({ location, children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Header location={location} siteTitle={data.site.siteMetadata.title} />
        <div
          style={{
            paddingTop: 0,
          }}
        >
          <Main>{children}</Main>
          <Fooer.View />
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
